import React from 'react';
import PropTypes from 'prop-types';
import { mergeStyles } from '@bingads-webui-react/fabric-control';
import { Header } from './header';

const panelStyles = mergeStyles({
  width: 928,
  background: '#FFFFFF',
  borderRadius: 4,
  boxShadow: '0px 1.600000023841858px 3.5999999046325684px 0px #00000021',
});

const panelContentStyles = mergeStyles({
  padding: '16px 24px 16px 24px',
});

export const Panel = ({
  header, headerDynamic, children,
}) =>
  (
    <div className={panelStyles}>
      {header && <Header {...header} {...headerDynamic} />}
      <div className={panelContentStyles}>
        {children}
      </div>
    </div>
  );

Panel.propTypes = {
  header: PropTypes.shape({}),
  headerDynamic: PropTypes.shape({}),
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]).isRequired,
};

Panel.defaultProps = {
  header: null,
  headerDynamic: null,
};
